import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { CheckboxState } from '../enum/checkbox-state';
import { BaseViewModel } from '../model/base-model';

@Injectable({
  providedIn: 'root'
})
export class GenericGridService {

  totalItemsSelected = new BehaviorSubject<number>(0);
  itemsSelecteds = new BehaviorSubject<any[]>([]);
  dataLength = new BehaviorSubject<number>(0);
  headerStateCheckBox = new BehaviorSubject<CheckboxState>(CheckboxState.Unchecked);
  optionMarkted = new BehaviorSubject<unknown>(null);
  constructor() { }

  getDataLength() {
    return this.dataLength;
  }

  setDataLength(value: number) {
    this.dataLength.next(value);
  }

  getTotalItemSelected() {
    return this.totalItemsSelected;
  }

  setTotalSelectedItem(value: number) {
    this.totalItemsSelected.next(value);
  }

  setItemSelected(newItem: any) {
    this.clearSeletectedItems();
    const currentValue  = this.itemsSelecteds.value;
    const updatedItens = [...currentValue, ...newItem];
    this.itemsSelecteds.next(updatedItens);
  }

  getItemsSelected() {
    return this.itemsSelecteds;
  }

  clearSeletectedItems() {
    this.itemsSelecteds.next([]);
  }

  resetHeaderStateCheckBox() {
    this.headerStateCheckBox.next(CheckboxState.Unchecked);
  }

  setHeaderStateCheckBoxToChecked() {
    this.headerStateCheckBox.next(CheckboxState.Checked);
  }

  setHeaderStateCheckBoxToIndeterminate() {
    this.headerStateCheckBox.next(CheckboxState.Indeterminate);
  }

  getHeaderStateCheckBox() {
    return this.headerStateCheckBox;
  }

  getOptionSelected() {
    return this.optionMarkted;
  }

  setOptionSelected(item: any) {
    this.optionMarkted.next(null);
    this.optionMarkted.next(item);
  }



}
